var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
/**
 * Component intended to be used within the `<nb-flip-card>` and `<nb-reveal-card>` components.
 *
 * Use it as a container for the front card.
 */
var NbCardFrontComponent = /** @class */ (function () {
    function NbCardFrontComponent() {
    }
    NbCardFrontComponent = __decorate([
        Component({
            selector: 'nb-card-front',
            template: '<ng-content select="nb-card"></ng-content>',
        })
    ], NbCardFrontComponent);
    return NbCardFrontComponent;
}());
export { NbCardFrontComponent };
/**
 * Component intended to be used within the `<nb-flip-card>` and `<nb-reveal-card>` components.
 *
 * Use it as a container for the back card.
 */
var NbCardBackComponent = /** @class */ (function () {
    function NbCardBackComponent() {
    }
    NbCardBackComponent = __decorate([
        Component({
            selector: 'nb-card-back',
            template: '<ng-content select="nb-card"></ng-content>',
        })
    ], NbCardBackComponent);
    return NbCardBackComponent;
}());
export { NbCardBackComponent };
//# sourceMappingURL=shared.component.js.map